// animations.js

export const fadeIn = (duration = 0.3, delay = 0) => ({
  hidden: { opacity: 0, scale: 0.9 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration, delay, ease: "easeInOut" },
  },
});

export const slideIn = (
  direction = "left",
  distance = "100%",
  duration = 0.3
) => {
  const x =
    direction === "left"
      ? `-${distance}`
      : direction === "right"
      ? `${distance}`
      : 0;
  const y =
    direction === "up"
      ? `-${distance}`
      : direction === "down"
      ? `${distance}`
      : 0;

  return {
    hidden: { opacity: 0, x, y },
    visible: {
      opacity: 1,
      x: 0,
      y: 0,
      transition: { duration, ease: "easeInOut" },
    },
  };
};

export const hoverEffect = (scale = 1.1, duration = 0.1) => ({
  whileHover: {
    scale,
    transition: { duration, ease: "easeInOut" },
  },
});

export const slideInOnScrollLeft = (distance = "100%", duration = 0.3) => ({
  hidden: { opacity: 0, x: `-${distance}` },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration, ease: "easeInOut" },
  },
});
export const slideInOnScrollRight = (distance = "100%", duration = 0.3) => ({
  hidden: { opacity: 0, x: `${distance}` },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration, ease: "easeInOut" },
  },
});

export const popIn = (duration = 0.3, delay = 0) => ({
  hidden: { opacity: 0, scale: 0.8 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration, delay, ease: "easeInOut" },
  },
});
